var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.showoff
    ? _c(
        "el-dialog",
        {
          attrs: { visible: _vm.showoff, title: "新增商品", width: "700px" },
          on: {
            "update:visible": function ($event) {
              _vm.showoff = $event
            },
          },
        },
        [
          _c(
            "el-form",
            { ref: "form", attrs: { "label-width": "100px" } },
            [
              _c(
                "el-form-item",
                { attrs: { label: "新增方式" } },
                [
                  _c(
                    "el-radio-group",
                    {
                      on: { change: _vm.changeType },
                      model: {
                        value: _vm.typeVale,
                        callback: function ($$v) {
                          _vm.typeVale = $$v
                        },
                        expression: "typeVale",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: 1 } }, [
                        _vm._v("直接新增"),
                      ]),
                      _c("el-radio", { attrs: { label: 2 } }, [
                        _vm._v("根据商品ID复制信息后新增"),
                      ]),
                      _c("el-input", {
                        staticClass: "goods-id-input",
                        attrs: {
                          placeholder: "请输入商品id",
                          disabled: _vm.typeVale === 1,
                        },
                        on: { input: _vm.inputIds },
                        model: {
                          value: _vm.goodsId,
                          callback: function ($$v) {
                            _vm.goodsId = $$v
                          },
                          expression: "goodsId",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "关联供应商" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "请输入供应商id" },
                    model: {
                      value: _vm.relationSupplierId,
                      callback: function ($$v) {
                        _vm.relationSupplierId = $$v
                      },
                      expression: "relationSupplierId",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "铺品渠道" } },
                [
                  _c(
                    "el-checkbox-group",
                    {
                      model: {
                        value: _vm.qudaoType,
                        callback: function ($$v) {
                          _vm.qudaoType = $$v
                        },
                        expression: "qudaoType",
                      },
                    },
                    [
                      _c("el-checkbox", { attrs: { disabled: "", label: 1 } }, [
                        _vm._v("农博优选"),
                      ]),
                      _c(
                        "el-radio-group",
                        {
                          model: {
                            value: _vm.yxIsOnSale,
                            callback: function ($$v) {
                              _vm.yxIsOnSale = $$v
                            },
                            expression: "yxIsOnSale",
                          },
                        },
                        [
                          _c("el-radio", { attrs: { label: 1 } }, [
                            _vm._v("上架"),
                            _c("span", { staticStyle: { color: "red" } }, [
                              _vm._v(
                                "（若商品未关联供应商，订单由农博优选店发货，请谨慎操作）"
                              ),
                            ]),
                          ]),
                          _c("el-radio", { attrs: { label: 0 } }, [
                            _vm._v("下架"),
                          ]),
                        ],
                        1
                      ),
                      _c("el-checkbox", { attrs: { label: 2 } }, [
                        _vm._v("渠道选品中心"),
                      ]),
                      _c("el-checkbox", { attrs: { label: 3 } }, [
                        _vm._v("ERP"),
                        _c("span", { staticStyle: { color: "red" } }, [
                          _vm._v(
                            "（若商品未关联供应商，订单由农博优选店发货，请谨慎操作）"
                          ),
                        ]),
                      ]),
                      _c("el-checkbox", { attrs: { label: 4 } }, [
                        _vm._v("中国土特产"),
                      ]),
                      _c(
                        "el-radio-group",
                        {
                          attrs: { disabled: !_vm.qudaoType.includes(4) },
                          model: {
                            value: _vm.ttcIsOnSale,
                            callback: function ($$v) {
                              _vm.ttcIsOnSale = $$v
                            },
                            expression: "ttcIsOnSale",
                          },
                        },
                        [
                          _c("el-radio", { attrs: { label: 1 } }, [
                            _vm._v("上架"),
                            _c("span", { staticStyle: { color: "red" } }, [
                              _vm._v(
                                "（若商品未关联供应商，订单由农博优选店发货，请谨慎操作）"
                              ),
                            ]),
                          ]),
                          _c("el-radio", { attrs: { label: 0 } }, [
                            _vm._v("下架"),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "btn-box" },
            [
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.submitBtn } },
                [_vm._v("确定")]
              ),
              _c("el-button", { on: { click: _vm.close } }, [_vm._v("取消")]),
            ],
            1
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }